import { getEducationCodeList } from '@/api/base-info/base-info.api'

let educationCodeRequest = null

export default {
  state: {
    educationCodes: [],
    educationCodesLoaded: false
  },
  getters: {
    educationCodes(state) {
      return state.educationCodes
    },
    educationCodeName(state) {
      return code => {
        const item = state.educationCodes.find(row => String(row.deptCode) === String(code))
        return item ? item.deptName : ''
      }
    }
  },
  mutations: {
    setEducationCodes(state, list) {
      state.educationCodes = Array.isArray(list) ? list : []
      state.educationCodesLoaded = true
    }
  },
  actions: {
    loadEducationCodes({ state, commit }, force) {
      if (state.educationCodesLoaded && !force) {
        return Promise.resolve(state.educationCodes)
      }
      if (educationCodeRequest && !force) return educationCodeRequest

      educationCodeRequest = getEducationCodeList().then(res => {
        const success = res && (Number(res.code) === 200 || Number(res.code) === 0 || res.success === true)
        if (!success || res.success === false) return Promise.reject(res)
        const list = Array.isArray(res.data) ? res.data : []
        commit('setEducationCodes', list)
        return list
      }).finally(() => {
        educationCodeRequest = null
      })
      return educationCodeRequest
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/educationCode.js